module.exports = {
	"is-mobile": {
		"max": "(max-width:479px)"
	},
	"is-mobileL": {
		"min": "(min-width:480px)",
		"max": "(max-width:767px)"
	},
	"is-tablet": {
		"min": "(min-width:768px)",
		"max": "(max-width:1023px)"
	},
	"is-desktop": {
		"min": "(min-width:1024px)",
		"max": "(max-width:1199px)"
	},
	"is-wide": {
		"min": "(min-width:1200px)"
	},
	"is-xxl": {
		"min": "(min-width:1300px)"
	},
	"is-webkit": "(-webkit-min-device-pixel-ratio: 0)",
	"is-retina": "(-webkit-min-device-pixel-ratio: 2), (min--moz-device-pixel-ratio: 2), (-o-min-device-pixel-ratio: 2/1), (min-device-pixel-ratio: 2), (min-resolution: 192dpi), (min-resolution: 2dppx)"
};


//////////////////
// WEBPACK FOOTER
// ./src/css/media-queries.json
// module id = 73
// module chunks = 0